/* Generated. This file cannot be edited directly. Please check codegen.ts for configuration. */
// @ts-nocheck

import * as Apollo from '@apollo/client'

import { gql } from '@apollo/client'
import * as Types from '../../../../graphql/src/lib/graphql/generated/types'

const defaultOptions = {} as const
export type UserFleetsQueryVariables = Types.Exact<{
  regionId?: Types.InputMaybe<Types.Scalars['String']['input']>
}>

export type UserFleetsQuery = {
  __typename?: 'Query'
  fleets: {
    __typename?: 'FleetsResponse'
    fleets: Array<{
      __typename?: 'Fleet'
      id: string
      name: string
      operatorTenant: string
    }>
  }
}

export const UserFleetsDocument = gql`
    query userFleets($regionId: String) {
  fleets(input: {regionId: $regionId}) {
    fleets {
      id
      name
      operatorTenant
    }
  }
}
    `

/**
 * __useUserFleetsQuery__
 *
 * To run a query within a React component, call `useUserFleetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserFleetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserFleetsQuery({
 *   variables: {
 *      regionId: // value for 'regionId'
 *   },
 * });
 */
export function useUserFleetsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    UserFleetsQuery,
    UserFleetsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<UserFleetsQuery, UserFleetsQueryVariables>(
    UserFleetsDocument,
    options,
  )
}
export function useUserFleetsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    UserFleetsQuery,
    UserFleetsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<UserFleetsQuery, UserFleetsQueryVariables>(
    UserFleetsDocument,
    options,
  )
}
// @ts-ignore
export function useUserFleetsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    UserFleetsQuery,
    UserFleetsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<UserFleetsQuery, UserFleetsQueryVariables>
export function useUserFleetsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        UserFleetsQuery,
        UserFleetsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  UserFleetsQuery | undefined,
  UserFleetsQueryVariables
>
export function useUserFleetsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        UserFleetsQuery,
        UserFleetsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<UserFleetsQuery, UserFleetsQueryVariables>(
    UserFleetsDocument,
    options,
  )
}
export type UserFleetsQueryHookResult = ReturnType<typeof useUserFleetsQuery>
export type UserFleetsLazyQueryHookResult = ReturnType<
  typeof useUserFleetsLazyQuery
>
export type UserFleetsSuspenseQueryHookResult = ReturnType<
  typeof useUserFleetsSuspenseQuery
>
export type UserFleetsQueryResult = Apollo.QueryResult<
  UserFleetsQuery,
  UserFleetsQueryVariables
>
